import { immortalRisingMainQuest } from "@/data-access/quests/immortalRisingQuests";
import { tokyoBeastMainQuest } from "@/data-access/quests/tokyoBeastQuests";
import type { Content } from "@prismicio/client";
import type { QuestState } from "@ui-kit/QuestList";
import { AssetHoldingModal } from "./QuestModals/AssetHoldingModal";
import { BonusQuestModal } from "./QuestModals/BonusQuestModal";
import { DarkMachineNFTModal } from "./QuestModals/DarkMachineNFTModal";
import { QuizQuestModal } from "./QuestModals/RavenQuest/QuizQuestModal";
import { SocialEngagementModal } from "./QuestModals/SocialEngagementModal";
import { TelegramQuestModal } from "./QuestModals/TelegramQuestModal";
import { VideoQuestModal } from "./QuestModals/VideoQuestModal";
import { RulesDialog } from "./QuestTiles/QuestTile/RulesDialog/RulesDialog";

export type QuestModalsControlsProps = {
  game: Content.GameDocument;
  quest?: QuestState;
  totalGemsGranted: number;
  onModalClose: (resetInProgress?: boolean) => void;
  onQuestComplete: () => Promise<void> | undefined;
};

export const QuestModalsControls = ({
  game,
  quest,
  onModalClose,
  onQuestComplete,
  totalGemsGranted,
}: QuestModalsControlsProps) => {
  if (!quest) return null;

  return (
    <>
      {quest.key === "ownership" && quest.assetHoldingToken && (
        <AssetHoldingModal
          quest={quest}
          visible={true}
          onClose={() => onModalClose(true)}
          onClaimPoints={onQuestComplete}
          onBuyClick={() => {
            if (quest?.assetHoldingToken?.purchaseUrl) {
              window.open(quest.assetHoldingToken.purchaseUrl, "_blank");
            }
          }}
        />
      )}
      {quest.key === "telegram-v2" && (
        <TelegramQuestModal
          gameId={(game.data.games_service_item?.id as string) ?? ""}
          gameName={game.data.name ?? ""}
          questKey={quest.key}
          ruleId={quest.ruleId}
          onClose={() => onModalClose(true)}
          onQuestComplete={onQuestComplete}
        />
      )}
      {quest.key === "social-engagement" && (
        <SocialEngagementModal
          gameId={(game.data.games_service_item?.id as string) || ""}
          gameName={game.data.name || ""}
          visible={true}
          onClose={() => onModalClose(true)}
          rewardType={quest.badgeIcon === "Sparkle" ? "points" : "gems"}
          questId={quest.ruleId}
        />
      )}
      {quest.type === "video" && quest.videoUrl && quest.videoMimeType && (
        <VideoQuestModal
          videoUrl={quest.videoUrl}
          videoMimeType={quest.videoMimeType}
          onClose={() => onModalClose(true)}
          onComplete={() => {
            onModalClose();
            onQuestComplete?.();
          }}
        />
      )}
      {/* Dark Machine promo modal  */}
      {quest.key === "bonus-variant-2" &&
        game.data.games_service_item?.id ===
          "165bc87e-ba42-46a5-b9e6-c6ea74e9b15c" && (
          <DarkMachineNFTModal onClose={() => onModalClose()} game={game} />
        )}
      {quest.key === "bonus-variant-2" &&
        game.data.games_service_item?.id ===
          "d99f87e1-9b4e-4e40-ad64-e319a0d79335" && (
          <RulesDialog
            quest={tokyoBeastMainQuest}
            isVisible
            testId={`${quest.key}-rules-dialog`}
            onClose={() => onModalClose()}
          />
        )}
      {quest.key === "bonus-variant-2" &&
        game.data.games_service_item?.id ===
          "96191677-0a86-4718-a863-d8e7818fc063" && (
          <RulesDialog
            quest={immortalRisingMainQuest}
            isVisible
            testId={`${quest.key}-rules-dialog`}
            onClose={() => onModalClose()}
          />
        )}
      {(quest.key === "in-game" || quest.key === "erc20") &&
        quest.ruleModal && (
          <RulesDialog
            quest={quest.ruleModal}
            isVisible
            testId={`${quest.key}-rules-dialog`}
            onClose={() => onModalClose()}
          />
        )}
      {quest.key === "bonus" && (
        <BonusQuestModal
          gameName={game?.data?.name as string}
          totalGemsGranted={totalGemsGranted}
          onClose={() => {
            onModalClose();
            onQuestComplete?.();
          }}
        />
      )}
      {quest.type === "quiz" && (
        <QuizQuestModal
          onClose={() => onModalClose()}
          onComplete={() => {
            onModalClose();
            onQuestComplete?.();
          }}
          quizVariant={
            quest.ruleId.includes("quiz-quest-a")
              ? "archetype"
              : quest.ruleId.includes("quiz-quest-b")
                ? "profession"
                : "test"
          }
          gameUid={game.uid}
        />
      )}
    </>
  );
};
